import { render, staticRenderFns } from "./InvPF_Client.vue?vue&type=template&id=5b214c7f"
import script from "./InvPF_Client.vue?vue&type=script&lang=js"
export * from "./InvPF_Client.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports